export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

export const isMasterAdmin = () => {
  const user = getCurrentUser();
  return user?.is_master_admin === 1 || user?.is_master_admin === true;
};

export const isCompanyAdmin = () => {
  const user = getCurrentUser();
  return user?.is_company_admin === 1 || user?.is_company_admin === true;
};

export const isAdmin = () => {
  return isMasterAdmin() || isCompanyAdmin();
};

export const canDonate = () => {
  const user = getCurrentUser();
  return user?.can_donate === 1 || user?.can_donate === true;
};

export const canReceive = () => {
  const user = getCurrentUser();
  return user?.can_receive === 1 || user?.can_receive === true;
};

export const hasBothRoles = () => {
  return canDonate() && canReceive();
};

export const getTabPermissions = () => {
  const user = getCurrentUser();
  let permissions = user?.tab_permissions;
  
  if (typeof permissions === "string") {
    try {
      permissions = JSON.parse(permissions);
    } catch {
      permissions = {};
    }
  }
  
  return permissions || {};
};

export const hasTabPermission = (section, permission) => {
  if (isAdmin()) return true;
  
  const permissions = getTabPermissions();
  return permissions[section]?.[permission] === true;
};
